import React, {useState, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import * as Common from '../../common/app_common';
import {getApiSitesCount, getApiSites, getApiSitesSite} from '../../common/fetch_api/site'
import {getApiEdgeId} from '../../common/fetch_api/edge'
import {getApiAlertCodes, postApiAlertRules, putApiAlertRulesId} from '../../common/fetch_api/alert'
import {getApiConfigSystem} from '../../common/fetch_api/configuration'

export const AddAlertModal = ({show, handleClose, update}) => {

    const [enableFalse, setEnableFalse] = useState({disabled:false});
    const [firstEndpoint, setFirstEndpoint] = useState('');

    const [recvCode, setRecvCode] = useState(null);
    const [recvEdge, setRecvEdge] = useState(null);

    const [addAlert, setAddAlert] = useState({enabled:true, site:'', edge:'', alert:'', conditionType:'', conditionOper:'==', conditionRight:0, severity:'', duration:'', firstEndpoint:'', secondEndpoint:'', description:''})
    const [siteList, setSiteList] = useState(null);
    const [edgeList, setEdgeList] = useState(null);
    const [alertList, setAlertList] = useState(null);
    const [severityList, setSeverityList] = useState(null);
    const [durationList, setDurationList] = useState(null);
    // const [firstEndpointList, setFirstEndpointList] = useState(null);
    const [secondEndpointList, setSecondEndpointList] = useState(null);

    const [range, setRange] = useState({min: 0, max: 100, type: 'none'});

    const onChangeAddAlert = (e, index) => {
        let temp = addAlert;
        let value = e.target.value;
        temp[index] = value;

        switch( index )
        {
            case 'enabled' :
            {
                setEnableFalse(value === 'false'?{disabled:true}:{disabled:false});
            }
            break;
            case 'site' :
            {
                getEdges(value, Object.values(recvCode.alertCode));
                temp['edge'] = '';
                temp['alert'] = '';
            }
            break;
            case 'edge' :
            {
                let edge = recvEdge.filter((x) => {return x.name === value})[0];
                getAlerts(edge, Object.values(recvCode.alertCode));
                temp['alert'] = '';
            }
            break;
            case 'alert' :
            {
                if( value === '')
                {
                    temp['conditionType'] = 'none';
                    setRange({min: 0, max: 0, type: 'none'});
                }
                else
                {
                    let alertCode = Object.values(recvCode.alertCode);
                    let code = alertCode.filter((x) => {return x.title === value})[0];
                    
                    temp['conditionType'] = code.type;
                    temp['conditionRight'] = 0;
                    if(code.type === 'none')
                    {
                        setRange({min: 0, max: 0, type: code.type});
                    }
                    else
                    {
                        setRange({min: code.range.min, max: code.range.max, type: code.type});
                    }
                }
            }
            break;
            default:break;
        }

        setAddAlert((prevState) => { return { ...prevState, temp } });
    }

    function getLists()
    {
        Promise.resolve( getApiAlertCodes() )
        .then( codes => {

            setRecvCode(codes);
                
            const alertCode = codes.alertCode;
            let normalTitles = [];
            for( const code of Object.keys(alertCode))
            {
                if( alertCode[code].required === false )
                {
                    normalTitles.push(alertCode[code].title);
                }
            }
            
            setAlertList( normalTitles.map( (title, index) =>
                <option key={index} value={title}>{title}</option>
            ));
            
            setSeverityList( codes.severity.map( (severity, index) =>
                <option key={index} value={severity}>{severity}</option>
            ));
            
            setDurationList( codes.duration.map( (duration, index) =>
                <option key={index} value={duration}>{`${duration} s`}</option>
            ));
            
            // setFirstEndpointList( codes.endpoint.map( (endpoint, index) =>
            //     <option key={index} value={endpoint}>{endpoint}</option>
            // ));
            
            let endpointList = [...codes.endpoint].filter( (item) => {return item !== firstEndpoint});
            setSecondEndpointList([ 
                <option key={-1} value={'Not Used'}>Not Used</option>,
                endpointList.map( (endpoint, index) =>
                    <option key={index} value={endpoint}>{endpoint}</option>
                )
            ]);
            
            let temp = addAlert;
            temp['severity'] = codes.severity[0];
            temp['duration'] = codes.duration[0];
            temp['firstEndpoint'] = codes.endpoint[0];
            temp['secondEndpoint'] = codes.endpoint[0];
            temp['description'] = codes.description || '';
            setAddAlert((prevState) => { return { ...prevState, temp } });

            return codes;
        })
        .then( codes => {
            Promise.resolve( getApiSitesCount('', '') )
            .then( data => {
                if(data)
                {
                    Promise.resolve( getApiSites(data.count, 1, '', '', 'name', 'asc') )
                    .then(siteArr => {
                        setSiteList( siteArr.map( (site, index) =>
                            <option key={index} value={site.site}>{site.site}</option>
                        ));
                        
                        getEdges('', Object.values(codes.alertCode));
                    });
                }
            });
        });
    }

    function getEdges(siteName, codes)
    {
        if( siteName === '')
        {
            setEdgeList( <option key={0} value={''}>{'All Edges'}</option> );
            getAlerts({name:''}, codes);
        }
        else
        {
            Promise.resolve( getApiSitesSite(siteName) )
            .then(edgeArr => {

                if( edgeArr.edgeList.length > 0 )
                {
                    setRecvEdge(edgeArr.edgeList);
                    
                    getAlerts(edgeArr.edgeList[0], codes);
                    
                    setEdgeList( edgeArr.edgeList.map( (edge, index) =>
                        <option key={index} value={edge.name}>{edge.name}</option>
                    ));
                }
                else
                {
                    setEdgeList( <option key={0} value={''}>{`All Edges (Doesn't have Edges)`}</option> );
                    getAlerts({name:''}, codes);
                }
            });
        }
    }

    function getAlerts(edge, alertCodes)
    {
        if( edge.name !== '' )        
        {
            alertCodes = alertCodes.filter((x) => {return x.edgeType.indexOf(edge.type) !== -1});
        }
        
        let normalTitles = [];
        for( const item of alertCodes)
        {
            if( item.required === false )
            {
                normalTitles.push(item.title);
            }
        }
        
        setAlertList( normalTitles.map( (title, index) =>
            <option key={index} value={title}>{title}</option>
        ));
    }

    useEffect(() => {
        Promise.resolve( getApiConfigSystem() )
        .then( data => {
            setFirstEndpoint(data.alert.defaultEndpoint)
        });

        getLists();
    }, []);

    const onClickConfirm = () => {

        if( addAlert.alert === '' )
        {
            Common.showToast("Alert is must requied!", 'error');
            return;
        }
        else if( addAlert.site !== '' && addAlert.edge === '' )
        {
            Common.showToast("Edge is must requied!", 'error');
            return;
        }

        let alertCode = Object.values(recvCode.alertCode).filter((x) => {return x.title === addAlert.alert})[0];

        let sendData = {
            "title": addAlert.alert,
            "code": alertCode.code,
            "enabled": addAlert.enabled,
            "edgeId": '',
            "condition": {
                "type": addAlert.conditionType,
                "left": 'metric',
                "operator": addAlert.conditionOper,
                "right": addAlert.conditionRight,
            },
            "duration": addAlert.duration,
            "severity": addAlert.severity,
            "firstEndpoint": firstEndpoint,
            "secondEndpoint": addAlert.secondEndpoint,
            "metric": alertCode.metric,
            "description": addAlert.description,
        };

        if( addAlert.site !== '' )
        {
            let edge = recvEdge.filter((x) => {return x.name === addAlert.edge})[0];
            sendData.edgeId = edge.id;
        }
        
        Promise.resolve( postApiAlertRules(sendData) )
        .then( done => {
            closeModal();
            update();
        });
    }

    const onClickCancel = () => {
        closeModal();
    }

    const closeModal = () => {
        handleClose();
        show = false;
    }

    const lintNumber = (e, index, type, min, max) => {
        let val;
        
        if(type === 'int')
        {
            val = parseInt(e.target.value) || min;
        }
        else
        {
            val = parseFloat(e.target.value) || min;
        }
        
        if( val < min )
        {
            val = min;
        }

        if( val > max )
        {
            val = max;
        }
        
        setAddAlert((prevState) => { return { ...prevState, [index]: val } });
    }

    return (        
        <Modal
            show={show}
            keyboard={true}
            onHide={closeModal}
            // backdrop="static"
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            >
            <Modal.Header>
                <h6 className="modal-title">Add Alert</h6>
                <Button variant='close' className="btn-close-white" onClick={onClickCancel}></Button>
            </Modal.Header>
            <Modal.Body className='add-alert-modal'>
                <div className="d-flex">
                    <div className="col-3 label-box">Enable</div>
                    <div className="col-9">
                        <select className="form-select form-select-sm" value={addAlert.enabled} onChange={(e) => {onChangeAddAlert(e, 'enabled')}}>
                            <option value='false'>Disabled</option>
                            <option value='true'>Enabled</option>
                        </select>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-3 label-box">Site</div>
                    <div className="col-9">
                        <select className="form-select form-select-sm" value={addAlert.site} onChange={(e) => {onChangeAddAlert(e, 'site')}} {...enableFalse}>
                            <option value=''>All Site</option>
                            {siteList}
                        </select>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-3 label-box">Edge</div>
                    <div className="col-9">
                        <select className="form-select form-select-sm" value={addAlert.edge} onChange={(e) => {onChangeAddAlert(e, 'edge')}} {...enableFalse}>
                            {addAlert.site !== ''&& <option value=''>--- Select Edge ---</option>}
                            {edgeList}
                        </select>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-3 label-box">Alert</div>
                    <div className="col-9">
                        <select className="form-select form-select-sm" value={addAlert.alert} onChange={(e) => {onChangeAddAlert(e, 'alert')}} {...enableFalse}>
                            <option value=''>--- Select Alert ---</option>
                            {alertList}
                        </select>
                    </div>
                </div>
                <div className="d-flex alert-condition">
                    <div className="col-3 label-box">Condition</div>
                    <div className="col-3">
                        <input className="form-control input-box" value={addAlert.conditionType} readOnly {...enableFalse}/>
                    </div>
                    {addAlert.conditionType === 'none' ?
                        <></>
                    :
                        <>
                            <div className="col-3">
                                <select className="form-select form-select-sm" value={addAlert.conditionOper} onChange={(e) => {onChangeAddAlert(e, 'conditionOper')}} {...enableFalse}>
                                    {addAlert.conditionType === 'bool' ?
                                        <option value='=='>==</option>
                                    :
                                        <>
                                            <option value='=='>==</option>
                                            <option value='>='>{`>=`}</option>
                                            <option value='<='>{`<=`}</option>
                                            <option value='>'>{`>`}</option>
                                            <option value='<'>{`<`}</option>
                                        </>
                                    }
                                </select>
                            </div>
                            <div className="col-3">
                                {addAlert.conditionType === 'bool'
                                ?
                                    <select className="form-select form-select-sm" value={addAlert.conditionRight} onChange={(e) => {onChangeAddAlert(e, 'conditionRight')}} {...enableFalse}>
                                        <option value={1}>True</option>
                                        <option value={0}>False</option>
                                    </select>
                                :
                                    <input className="form-control input-box" type='text' title={`${range.min} ~ ${range.max}`} value={addAlert.conditionRight}
                                        onChange={(e) => {onChangeAddAlert(e, 'conditionRight')}}
                                        onBlur={(e) => {lintNumber(e, 'conditionRight', addAlert.conditionType, range.min, range.max)}}
                                        {...enableFalse}
                                    />
                                }
                            </div>
                        </>
                    }
                </div>
                <div className="d-flex">
                    <div className="col-3 label-box">Serverity</div>
                    <div className="col-9">
                        <select className="form-select form-select-sm" value={addAlert.severity} onChange={(e) => {onChangeAddAlert(e, 'severity')}} {...enableFalse}>
                            {severityList}
                        </select>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-3 label-box">Duration</div>
                    <div className="col-9">
                        <select className="form-select form-select-sm" value={addAlert.duration} onChange={(e) => {onChangeAddAlert(e, 'duration')}} {...enableFalse}>
                            {durationList}
                        </select>
                    </div>
                </div>
                <div className="d-flex first-endpoint">
                    <div className="col-3 label-box">First Endpoint</div>
                    <div className="col-9">
                        <input className="form-control input-box" value={firstEndpoint} readOnly {...enableFalse}/>
                        {/* <select className="form-select form-select-sm" value={addAlert.firstEndpoint} onChange={(e) => {onChangeAddAlert(e, 'firstEndpoint')}} {...enableFalse}>
                            {firstEndpointList}
                        </select> */}
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-3 label-box">Second Endpoint</div>
                    <div className="col-9">
                        <select className="form-select form-select-sm" value={addAlert.secondEndpoint} onChange={(e) => {onChangeAddAlert(e, 'secondEndpoint')}}>
                            {secondEndpointList}
                        </select>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-3 label-box">Description</div>
                    <div className="col-9">
                        <textarea className="form-control desc-memo" maxLength="65535" value={addAlert.description} onChange={(e) => {onChangeAddAlert(e, 'description')}} {...enableFalse}></textarea>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" className="btn-sm" onClick={onClickCancel}>Cancel</Button>
                <Button variant="success" className="btn-sm" onClick={onClickConfirm}>Add</Button>
            </Modal.Footer>
        </Modal>
    );
};

export const EditAlertModal = ({ruleInfo, show, handleClose, update}) => {

    const [enableFalse, setEnableFalse] = useState({disabled:true});

    const [editInfo, setEditInfo] = useState({site:'', edge:''});
    const [editAlert, setEditAlert] = useState({enabled:false, conditionType:'', conditionOper:'==', conditionRight:0, severity:'', duration:'', firstEndpoint:'', secondEndpoint:'', description:''})
    const [severityList, setSeverityList] = useState(null);
    const [durationList, setDurationList] = useState(null);
    const [firstEndpointList, setFirstEndpointList] = useState(null);
    const [secondEndpointList, setSecondEndpointList] = useState(null);

    const [range, setRange] = useState({min: 0, max: 100, type: 'none'});

    const onChangeAddAlert = (e, index) => {
        let temp = editAlert;
        let value = e.target.value;
        temp[index] = value;

        if( index === 'conditionRight' )
        {
            if( value <= range.min )
            {
                temp[index] = range.min;
            }
            else if( value >= range.max )
            {
                temp[index] = range.max;
            }

            if( range.type === 'int' )
            {
                temp[index] = parseInt(temp[index]);                    
            }
            else if( range.type === 'float' )
            {
            }
        }
        else if( index === 'enabled' )
        {
            setEnableFalse(value === 'false'?{disabled:true}:{disabled:false});
        }

        setEditAlert((prevState) => { return { ...prevState, temp } });
    }

    function getLists()
    {
        Promise.resolve( getApiAlertCodes() )
        .then( codes => {
            
            setSeverityList( codes.severity.map( (severity, index) =>
                <option key={index} value={severity}>{severity}</option>
            ));
            
            setDurationList( codes.duration.map( (duration, index) =>
                <option key={index} value={duration}>{`${duration} s`}</option>
            ));
            
            setFirstEndpointList( codes.endpoint.map( (endpoint, index) =>
                <option key={index} value={endpoint}>{endpoint}</option>
            ));
            
            setSecondEndpointList([ 
                <option key={-1} value={'Not Used'}>Not Used</option>,
                codes.endpoint.map( (endpoint, index) => <option key={index} value={endpoint}>{endpoint}</option>)
            ]);
            
            let alertCode = Object.values(codes.alertCode).filter((x) => {return x.code === ruleInfo.rule.code})[0];

            if(alertCode.type === 'none')
            {
                setRange({min: 0, max: 0, type: alertCode.type});
            }
            else
            {
                setRange({min: alertCode.range.min, max: alertCode.range.max, type: alertCode.type});
            }

            let temp = editAlert;
            temp['enabled'] = ruleInfo.rule.enabled;
            temp['conditionType'] = ruleInfo.rule.condition.type;
            temp['conditionOper'] = ruleInfo.rule.condition.operator;
            temp['conditionRight'] = ruleInfo.rule.condition.right;
            temp['severity'] = ruleInfo.rule.severity;
            temp['duration'] = ruleInfo.rule.duration;
            temp['firstEndpoint'] = ruleInfo.rule.firstEndpoint;
            temp['secondEndpoint'] = ruleInfo.rule.secondEndpoint;
            temp['description'] = ruleInfo.rule.description;
            setEditAlert((prevState) => { return { ...prevState, temp } });
            
            return codes;
        });
    }

    useEffect(() => {
        setEnableFalse(ruleInfo.rule.enabled?{disabled:false}:{disabled:true});

        if( ruleInfo.rule.edgeId )
        {
            Promise.resolve( getApiEdgeId(ruleInfo.rule.edgeId) )
            .then(data => {
                if( data )
                {
                    setEditInfo({site:data.site, edge:data.name});
                }
            });
        }
        else
        {
            setEditInfo({site:'All Site', edge:'All Edge'});
        }
        
        getLists();
    }, []);

    const onClickConfirm = () => {
        let rule = ruleInfo.rule;
        let sendData = {
            "title": rule.title,
            "code": rule.code,
            "enabled": editAlert.enabled,
            "edgeId": ruleInfo.rule.edgeId,
            "condition": {
                "type": editAlert.conditionType,
                "left": 'metric',
                "operator": editAlert.conditionOper,
                "right": editAlert.conditionRight,
            },
            "duration": editAlert.duration,
            "severity": editAlert.severity,
            "firstEndpoint": editAlert.firstEndpoint,
            "secondEndpoint": editAlert.secondEndpoint,
            "metric": rule.metric,
            "description": editAlert.description,
        };
        
        Promise.resolve( putApiAlertRulesId(sendData, ruleInfo.id) )
        .then( done => {
            closeModal();
            update();
        });
    }

    const onClickCancel = () => {
        closeModal();
    }

    const closeModal = () => {
        handleClose();
        show = false;
    }

    return (        
        <Modal
            show={show}
            keyboard={true}
            onHide={closeModal}
            // backdrop="static"
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            >
            <Modal.Header>
                <h6 className="modal-title">Edit Alert</h6>
                <Button variant='close' className="btn-close-white" onClick={onClickCancel}></Button>
            </Modal.Header>
            <Modal.Body className='edit-alert-modal'>
                <div className="d-flex">
                    <div className="col-3 label-box">Enable</div>
                    <div className="col-9">
                        <select className="form-select form-select-sm" value={editAlert.enabled} onChange={(e) => {onChangeAddAlert(e, 'enabled')}}>
                            <option value='false'>Disabled</option>
                            <option value='true'>Enabled</option>
                        </select>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-3 label-box">Site</div>
                    <div className="col-9">
                        <input className="form-control input-box" value={editInfo.site} readOnly {...enableFalse}/>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-3 label-box">Edge</div>
                    <div className="col-9">
                        <input className="form-control input-box" value={editInfo.edge} readOnly {...enableFalse}/>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-3 label-box">Alert</div>
                    <div className="col-9">
                        <input className="form-control input-box" value={ruleInfo.rule.title} readOnly {...enableFalse}/>
                    </div>
                </div>
                <div className="d-flex alert-condition">
                    <div className="col-3 label-box">Condition</div>
                    <div className="col-3">
                        <input className="form-control input-box" value={ruleInfo.rule.condition.type} readOnly {...enableFalse}/>
                    </div>
                    {editAlert.conditionType === 'none' ?
                        <></>
                    :
                        <>
                            <div className="col-3">
                                <select className="form-select form-select-sm" value={editAlert.conditionOper} onChange={(e) => {onChangeAddAlert(e, 'conditionOper')}} {...enableFalse}>
                                    {editAlert.conditionType === 'bool' ?
                                        <option value='=='>==</option>
                                    :
                                        <>
                                            <option value='=='>==</option>
                                            <option value='>='>{`>=`}</option>
                                            <option value='<='>{`<=`}</option>
                                            <option value='>'>{`>`}</option>
                                            <option value='<'>{`<`}</option>
                                        </>
                                    }
                                </select>
                            </div>
                            <div className="col-3">
                                {editAlert.conditionType === 'bool' ?
                                    <select className="form-select form-select-sm" value={editAlert.conditionRight} onChange={(e) => {onChangeAddAlert(e, 'conditionRight')}} {...enableFalse}>
                                        <option value={1}>True</option>
                                        <option value={0}>False</option>
                                    </select>
                                :
                                    <input className="form-control input-box" title={`${range.min} ~ ${range.max}`} value={editAlert.conditionRight} onChange={(e) => {onChangeAddAlert(e, 'conditionRight')}} {...enableFalse}/>
                                }
                            </div>
                        </>
                    }
                </div>
                <div className="d-flex">
                    <div className="col-3 label-box">Serverity</div>
                    <div className="col-9">
                        <select className="form-select form-select-sm" value={editAlert.severity} onChange={(e) => {onChangeAddAlert(e, 'severity')}} {...enableFalse}>
                            {severityList}
                        </select>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-3 label-box">Duration</div>
                    <div className="col-9">
                        <select className="form-select form-select-sm" value={editAlert.duration} onChange={(e) => {onChangeAddAlert(e, 'duration')}} {...enableFalse}>
                            {durationList}
                        </select>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-3 label-box">First Endpoint</div>
                    <div className="col-9">
                        <select className="form-select form-select-sm" value={editAlert.firstEndpoint} onChange={(e) => {onChangeAddAlert(e, 'firstEndpoint')}} disabled >
                            {firstEndpointList}
                        </select>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-3 label-box">Second Endpoint</div>
                    <div className="col-9">
                        <select className="form-select form-select-sm" value={editAlert.secondEndpoint} onChange={(e) => {onChangeAddAlert(e, 'secondEndpoint')}} {...enableFalse}>
                            {secondEndpointList}
                        </select>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-3 label-box">Description</div>
                    <div className="col-9">
                        <textarea className="form-control desc-memo" maxLength="65535" value={editAlert.description} onChange={(e) => {onChangeAddAlert(e, 'description')}} {...enableFalse}></textarea>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" className="btn-sm" onClick={onClickCancel}>Cancel</Button>
                <Button variant="success" className="btn-sm" onClick={onClickConfirm}>Save</Button>
            </Modal.Footer>
        </Modal>
    );
};